import React from 'react';

export default function SectionPageHeader({ description }) {
  if (!description) return null;
  return (
    <div className="small-padding section-page-header max-width-container full-width">
      <p>{description}</p>
    </div>
  );
}
